<template>
  <div class="praise-container">
    <div class="left">
      <div class="left-item">
        <cus-border title="总评数" bgColor="RGBA(4, 47, 62, .8)" ref="blya1">
          <div class="comment-total-group">
            <div
              class="comment-total-item"
              v-for="(item, index) in commentTotalList"
              :key="index"
            >
              <comment-total :item="item"></comment-total>
            </div>
          </div>
        </cus-border>
      </div>
      <div class="left-item">
        <cus-border
          title="评论热度趋势"
          bgColor="RGBA(4, 47, 62, .8)"
          ref="blya2"
        >
          <line-statis :item="degreeHeat"></line-statis>
        </cus-border>
      </div>
      <div class="left-item">
        <cus-border
          title="评论满意度趋势"
          bgColor="RGBA(4, 47, 62, .8)"
          ref="blya3"
        >
          <line-statis :item="satisfaction"></line-statis>
        </cus-border>
      </div>
      <div class="left-item">
        <cus-border title="评论热词" bgColor="RGBA(4, 47, 62, .8)" ref="blya4">
          <cloud-word>
            <line-statis></line-statis>
          </cloud-word>
        </cus-border>
      </div>
      <div class="left-item">
        <cus-border
          title="热度分布TOP5"
          bgColor="RGBA(4, 47, 62, .8)"
          ref="blya5"
        >
          <degree-heat :list="spread"></degree-heat>
        </cus-border>
      </div>
      <div class="left-item">
        <cus-border
          title="满意度分布TOP5"
          bgColor="RGBA(4, 47, 62, .8)"
          ref="blya6"
        >
          <degree-heat :list="satisfaction2"></degree-heat>
        </cus-border>
      </div>
      <div class="left-item">
        <cus-border title="行业评价分布" bgColor="#01060D" ref="blya7">
          <industry-evaluation :item="indicator"></industry-evaluation>
        </cus-border>
      </div>
      <div class="left-item">
        <cus-border
          title="近12月好评趋势"
          bgColor="RGBA(4, 47, 62, .8)"
          ref="blya8"
        >
          <line-statis :item="praiseTrend"></line-statis>
        </cus-border>
      </div>
      <div class="left-item">
        <cus-border
          title="近12月差评趋势"
          bgColor="RGBA(4, 47, 62, .8)"
          ref="blya9"
        >
          <line-statis :item="differenceTrend"></line-statis>
        </cus-border>
      </div>
    </div>
    <div class="right">
      <cus-border title="评论列表" bgColor="RGBA(4, 47, 62, .8)" ref="blya10">
        <comment-list></comment-list>
      </cus-border>
    </div>
  </div>
</template>
<script>
  // 导入边框组件
  import cusBorder from '@/components/cus-border/cus-border'
  // 导入总评数
  import commentTotal from './components/comment-total'
  // 折线统计图
  import lineStatis from './components/line-statis'
  // 导入词云
  import cloudWord from './components/cloud-word'
  // 导入柱状分布图
  import degreeHeat from './components/degree-heat'
  // 导入雷达图
  import industryEvaluation from './components/industry-evaluation'
  // 导入好评列表部分
  import commentList from './components/comment-list'
  export default {
    components: {
      cusBorder,
      commentTotal,
      lineStatis,
      cloudWord,
      degreeHeat,
      industryEvaluation,
      commentList,
    },
    data() {
      return {
        //   评论总数
        commentTotalList: [
          {
            total: 299,
            name: '好评',
            number: 186,
            color: '#4598FD',
            borderColor: '#02FFA3',
          },
          {
            total: 299,
            name: '中评',
            number: 89,
            color: '#23EE88',
            borderColor: '#FFCC02',
          },
          {
            total: 299,
            name: '差评',
            number: 24,
            color: '#FFB041',
            borderColor: '#B6712D',
          },
        ],
        // 评论热度趋势
        degreeHeat: {
          xData: [1, 2, 3, 4, 5, 6, 7],
          val: [100, 15, 145, 168, 56, 86, 90],
          color: '85, 238, 248',
        },
        // 评论满意度趋势
        satisfaction: {
          xData: [1, 2, 3, 4, 5, 6, 7],
          val: [168, 56, 86, 90, 100, 15, 145],
          color: '255, 204, 0',
        },
        // 热度分布top5
        spread: [
          { total: 100, number: 63, color: '255, 174, 0' },
          { total: 100, number: 58, color: '255, 174, 0' },
          { total: 100, number: 39, color: '255, 174, 0' },
          { total: 100, number: 33, color: '255, 174, 0' },
          { total: 100, number: 26, color: '255, 174, 0' },
        ],
        // 满意度分布top5
        satisfaction2: [
          { total: 100, number: 80, color: '0, 255, 162' },
          { total: 100, number: 54, color: '0, 255, 162' },
          { total: 100, number: 12, color: '0, 255, 162' },
          { total: 100, number: 35, color: '0, 255, 162' },
          { total: 100, number: 68, color: '0, 255, 162' },
        ],
        // 雷达图
        indicator: {
          data: [300, 356, 256, 375, 323, 378, 400, 254, 356, 312],
          indicator: [
            { name: '酒店', max: 500 },
            { name: '风景', max: 500 },
            { name: '体验', max: 500 },
            { name: '餐饮', max: 500 },
            { name: '服务', max: 500 },
            { name: '其他', max: 500 },
            { name: '环境', max: 500 },
            { name: '人气', max: 500 },
            { name: '交通', max: 500 },
            { name: '价格', max: 500 },
          ],
        },
        // 近十二月好评趋势
        praiseTrend: {
          xData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          val: [45, 24, 254, 452, 445, 214, 457, 154, 156, 235, 54, 12],
          color: '2, 135, 238',
        },
        // 近十二月差评趋势
        differenceTrend: {
          xData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          val: [78, 574, 54, 24, 41, 45, 21, 244, 54, 87, 487, 45],
          color: '180, 0, 255',
        },
      }
    },
    mounted() {
      this.init()
    },
    beforeDestroy() {
      this.$animejs.remove(['.svg-container', '.left-item', '.right'])
    },
    methods: {
      // 初始化
      init() {
        let anime = this.$animejs
        anime({
          targets: '.left-item',
          translateX: [-600, 0],
          scale: [0, 1],
          easing: 'easeInOutSine',
          delay: anime.stagger(100),
          // scale: [
          //   { value: 0.8, easing: 'easeOutSine', duration: 500 },
          //   { value: 1, easing: 'easeInOutQuad', duration: 800 },
          // ],
          // delay: this.$animejs.stagger(100, { grid: [14, 5], from: 'center' }),
        })
        anime({
          targets: '.right',
          translateX: [600, 0],
          scale: [0, 1],
          easing: 'easeInOutSine',
          delay: 300,
        })
        window.onresize = () => {
          this.$refs.blya1.init()
          this.$refs.blya2.init()
          this.$refs.blya3.init()
          this.$refs.blya4.init()
          this.$refs.blya5.init()
          this.$refs.blya6.init()
          this.$refs.blya7.init()
          this.$refs.blya8.init()
          this.$refs.blya9.init()
          this.$refs.blya10.init()
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .praise-container {
    padding: 1.45833vw;
    display: flex;
    flex-direction: row;
    position: relative;
    z-index: 4;
    .left {
      flex-grow: 1;
      margin-right: 1.45833vw;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      .left-item {
        width: calc((100% - 2.91666vw) / 3);
        height: 26vh;
        margin-bottom: 2vh;
      }
    }
    .right {
      width: 22.70833vw;
      height: 82vh;
    }
    // 总评数
    .comment-total-group {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 100%;
      align-items: center;
      .comment-total-item {
      }
    }
  }
</style>
